// extracted by mini-css-extract-plugin
export default {"pageTitle":"date_pageTitle__8AKQH","date":"date_date__fdFek"};